import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

function Header() {
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(Boolean(localStorage.getItem("accessToken")));

  useEffect(() => {
    const syncAuthState = () => {
      setIsLoggedIn(Boolean(localStorage.getItem("accessToken")));
    };

    syncAuthState();
    window.addEventListener("authChange", syncAuthState);
    window.addEventListener("storage", syncAuthState);
    window.addEventListener("focus", syncAuthState);
    return () => {
      window.removeEventListener("authChange", syncAuthState);
      window.removeEventListener("storage", syncAuthState);
      window.removeEventListener("focus", syncAuthState);
    };
  }, [location.pathname]);

  const handleClick = (id) => {
    if (window._jqNavLinks) {
      window._jqNavLinks(id);
    } else {
      console.error("_jqNavLinks function not found");
    }
  };

  return (
    <div className="header-section">
      <div className="row">
        <div className="col-md-3 col-sm-3 col-3">
          <div id="logo">
            <img src="images/open-tennis-logo.png" alt="" />
          </div>
        </div>
        <header className="col-md-9 col-sm-9 col-9">
          <h3 id="enter-lnk" onClick={() => handleClick(1)}>Enter Site</h3>
          {!isLoggedIn && (
            <h3 id="signup-lnk" onClick={() => handleClick(2)}>Sign Up</h3>
          )}
          {!isLoggedIn && (
            <h3 id="login-lnk" onClick={() => handleClick(3)}>Login</h3>
          )}
          <h3 id="video-lnk" onClick={() => handleClick(4)}>View Demo</h3>
        </header>
      </div>
    </div>
  )
}

export default Header